module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_simple_rec_16.4a9c833d.png";